import { createListApiSchema } from '../General/schemas';
import z from 'zod';

export const reportKindSchema = z.enum(['occupancy', 'time-on-site']);
export const reportStatusSchema = z.enum(['pending', 'completed', 'failed']);

export const reportSchema = z.object({
	id: z.string(),
	kind: reportKindSchema,
	name: z.string().optional(),
	status: reportStatusSchema,
	fileReference: z.string().optional(),
	filters: z.object({
		startDate: z.coerce.date().describe('The start date of the report'),
		endDate: z.coerce.date().describe('The end date of the report'),
		siteId: z.string().optional().describe('The site ID of the report'),
		roleIds: z.array(z.string()).optional().describe('The role IDs of the report'),
		groupIds: z.array(z.string()).optional().describe('The group IDs of the report'),
	}),
	createdAt: z.coerce.date().optional(),
	updatedAt: z.coerce.date().optional(),
});

export const reportListResponseSchema = createListApiSchema(reportSchema);
